import { style } from '@vanilla-extract/css';

export const paginationLoadMore = style({
  fontSize: '16px !important',
});

export const paginationContainer = style({
  paddingTop: 'var(--pagination-margin-top)',
});
